import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography, Alert } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import API_CONFIG from '../config/api';

/**
 * Consome token da sessão após OAuth Google e entra no app.
 * Tokens Gmail ficam só no backend.
 */
export default function GoogleLoginCallbackPage() {
  const { applySessionFromToken } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const token = params.get('token');
    const returnTo = params.get('returnTo') || '/home';
    if (!token) {
      setError('Token de sessão ausente.');
      return;
    }
    (async () => {
      try {
        const ok = await applySessionFromToken(token);
        if (!ok) {
          setError('Não foi possível concluir o login Google.');
          return;
        }
        navigate(returnTo.startsWith('/') ? returnTo : '/home', { replace: true });
      } catch (e) {
        setError(e.message || 'Falha no login Google.');
      }
    })();
  }, [params, applySessionFromToken, navigate]);

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      {error ? (
        <Alert severity="error" sx={{ maxWidth: 480 }}>
          {error}
          <Box sx={{ mt: 1 }}>
            <a href={`${window.location.origin}/login`}>Voltar ao login</a>
          </Box>
        </Alert>
      ) : (
        <Box sx={{ textAlign: 'center' }}>
          <CircularProgress />
          <Typography sx={{ mt: 2 }}>Concluindo login com Google…</Typography>
          <Typography variant="caption" color="text.secondary" display="block">
            Backend: {API_CONFIG.BACKEND_URL}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
